import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { SupportV1Redirect } from "./support-v1-redirect";

// Every deprecated support-v1 path maps to support-v2.
export const supportRoutes: PermissionedRouteObject[] = [
  { path: "*", element: <SupportV1Redirect /> },
];
